import Heading from "../Heading";
import Icon from "../Icon";
import Text from "../Text";
import React from 'react';
import { mq, styled } from "../../utils";
var StyledContact = styled.a(function (_a) {
    var _b = _a.theme, colors = _b.colors, font = _b.font;
    return "\n  && {\n    align-items: center;\n    justify-content: space-between;\n  }  \n  \n  padding: 4px 9px;\n  background-color: " + colors.primary + ";\n  \n  svg {\n    width: 28px;\n    height: 28px;\n    margin-right: 6px;\n  }\n  \n  div {\n    display: flex;\n    align-items: center;\n  }\n\n  p, h2 {\n    color: " + colors.white + ";\n  }\n  \n  p {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.71;\n    letter-spacing: 0.64px;\n  }\n  \n  h2 {\n    line-height: 1.71;\n    font-size: 14px;\n    font-family: " + font.family.proximaNova + ";\n    letter-spacing: 0.51px;\n  }\n";
}, mq({
    display: ['flex', 'flex', 'none'],
}));
var ContactDesktop = function (_a) {
    var label = _a.label, phone = _a.phone, phoneHref = _a.phoneHref;
    return (React.createElement(StyledContact, { "data-component": "ContactMobile", href: "tel:" + (phoneHref || phone) },
        React.createElement(Text, null, label),
        React.createElement("div", null,
            React.createElement(Icon.Phone, { color: "#fff", background: "#5dd7cd" }),
            React.createElement(Heading.Heading2, null, phone))));
};
export default ContactDesktop;
//# sourceMappingURL=ContactMobile.js.map